export default "__VITE_ASSET__DBGC5oPD__"